import { useNavigate } from "react-router-dom";
import { getImg } from "../../Api/getImg";
import i18n from "../../i18n";

export default function BlogCard({ id,title, image, summary, date, index }) {
const navigate=useNavigate()
    return (
        <div 
        onClick={()=>{navigate(`blog/${id}`)}}
            className=" bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl hover:scale-105 cursor-pointer transition-all duration-300 animate-fade-in"
            style={{ animationDelay: `${index * 0.1}s` }}
        >
            <div className="relative">
                <img
                    src={getImg(image)}
                    alt={title}
                    className="w-full h-62 sm:h-72 object-cover"
                    loading="lazy"
                    onError={(e) => (e.target.src = 'https://via.placeholder.com/400x300?text=Fallback+Image')}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
            <div className="p-4 bg-cardColor sm:p-5 flex flex-col justify-between h-[200px] sm:h-[220px]">
                <div>
                    <h3 className="text-base sm:text-lg font-semibold text-primary mb-2 line-clamp-2">
                        {title}
                    </h3>
                    <p className="text-gray-600 text-sm sm:text-base line-clamp-3">
                        {summary}
                    </p>
                </div>
                <div className="flex justify-between items-center mt-3">
                    <p className="text-xs sm:text-sm text-gray-400">{date}</p>
                    <button
                        className="text-xs sm:text-sm goldy-animate font-medium hover:scale-105 transition-all duration-200"
                        aria-label={`Read more about ${title}`}
                    >
                        {i18n.language=="ar"?"قراءة المزيد":"Read More"}
                    </button>
                </div>
            </div>

            <style jsx>{`
                @keyframes fade-in {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .animate-fade-in {
                    animation: fade-in 0.5s ease-in-out;
                }
            `}</style>
        </div>
    );
}
